<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import Loader from "../components/loader.vue";
import api from "@/axios";
import moment from "moment/moment";
import Swal from "sweetalert2";
import DropZone from "@/components/widgets/dropZone.vue";
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import {
  DxColumn,
  DxColumnFixing, DxDataGrid, DxExport,
  DxFilterRow, DxGrouping,
  DxGroupPanel,
  DxRemoteOperations,
} from "devextreme-vue/data-grid";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Movimento CT-e",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    DxGrouping,
    DxColumnFixing,
    DxExport,
    DxDataGrid,
    DxColumn,
    DxFilterRow, DxGroupPanel, DxRemoteOperations, DropZone, Layout, PageHeader, Loader },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    // return { dropzoneFile, drop};


    return { v$: useVuelidate(), dropzoneFile, drop };
  },
  data() {
    return {
      bloqExibEconofrete: false,


      itensCotaData: {},
      itemCotaRemet: {},
      itemCotaPrazoMin: {},
      itemCotaValorMin: {},

      cotaFreteListData: {},
      loadingCotarFrete: false,
      showModalCotarFrete: false,

      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      mediasData: {},
      loadingFiles: false,

      errosValid: null,
      pedTipoData: {},
      emitData: {},
      faturasData: {},
      faturasParcData: {},
      transpData: {},
      itensCteData: {},
      movCteData: {},

      idData: 0,
      updating: true,

      submitted: false,
      remetData: {},
      expedData: {},
      recebData: {},
      destData: {},

      cotaFrtData: null,
      cotaFrtCalcsData: null,


      title: "Editar Movimento CT-e",
      items: [
        {
          text: "Listagem de CT-e(s)",
          href: "/movctes/listnova",
        },
        {
          text: "Editar Movimento CT-e",
          active: true,
        },
      ],
      flagShowConciliacoes: false
    };
  },

  created() {

    if (window.location.href.includes('lelloprint')
        || window.location.href.includes('bluevix')
        || window.location.href.includes('belfar')
        || window.location.href.includes('creative')) {
      this.bloqExibEconofrete = true
    }

  },

  methods: {

    cancelar() {
      console.log('cancelar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de CT-e",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.post(`${getBaseUrl()}api/movctecanc`, {
            iddata: this.idData
          }).then((res) => {

            console.log('then axios')
            console.log(res.data[0])


            this.movCteData.status = 'CAN'
            this.updating = false

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "CT-e cancelado com sucesso",
              showConfirmButton: false,
              timer: 1500
            })

          })
        }
      })

    },


    cotarFrete(){
      console.log('cotarFrete_cte')

      this.showModalCotarFrete = true
      this.loadingCotarFrete = true
      this.cotaFreteListData = {}

      api.get(`${getBaseUrl()}api/cotarfretecte`, {
        params: {
          iddata: this.idData
        }
      }).then((res) => {
        console.log('res cotarFrete')
        console.log(res.data)

        const resEcono = res.data

        if (resEcono['SDT_WSRetorno'] && resEcono['SDT_WSRetorno']['Messages']) {
          console.log('existe erro')
          let erros = resEcono['SDT_WSRetorno']['Messages']
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          erros.forEach((erro) => {
            listaErros.push({
              'titulo': erro['Description'],
              'mensagem': erro['Type']
            })
          })
          this.errosValid = listaErros
          this.showModalCotarFrete = false
        }

        else if (resEcono[1]) {
          console.log('existe resultado')

          this.cotaFreteListData = resEcono[0]
          this.itensCotaData = resEcono[1]

          this.itensCotaData.forEach((value) => {
            if (value.cnpjremet === 1) {
              this.itemCotaRemet = value
            }
            if (value.prazomin === 1) {
              this.itemCotaPrazoMin = value
            }
            if (value.valormin === 1) {
              this.itemCotaValorMin = value
            }
          })

          this.movCteData = resEcono[2]

          this.loadingCotarFrete = false

        }
      })

    },

    downFile(path, nomeArq){
      console.log('downFile: ' + path)
      //console.log('downFile: ' + path.split('.').pop())
      this.loadingFiles = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: { pathData: path }
      }).then((res) => {
        console.log('res down')
        console.log(res)
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', nomeArq);
        document.body.appendChild(fileLink);
        console.log('fileLink')
        console.log(fileURL)
        fileLink.click();
        this.loadingFiles = false
      })
    },

    delFile(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingFiles = true
          api.delete(`${getBaseUrl()}api/media`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.loadingFiles = false
            this.mediasData = res.data[0]
          })
        }
      })
    },

    imprimirdancte() {
      console.log('baixardancte')
      const cteID = this.movCteData.id
      const payload = {
        ids: [cteID]
      }

      api.post(`${getBaseUrl()}api/movctegeradancte`, payload, { responseType: 'blob' }).then((res) => {
        console.log('Resposta enviar-ids (blob):', res)
        if (res && res.status === 200) {
          // tentar interpretar possíveis erros retornados como JSON dentro do blob
          const contentType = res.headers['content-type'] || ''

          if (contentType.includes('application/json')) {
            // é um JSON (provavelmente erro) -> ler e mostrar mensagem
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const text = reader.result
                const obj = JSON.parse(text)
                const msg = obj.message || obj.msg || JSON.stringify(obj)
                Swal.fire('Erro', msg, 'error')
              } catch (e) {
                Swal.fire('Erro', 'Resposta inválida do servidor.', 'error')
              }
            }
            reader.readAsText(res.data)
            return
          }

          // se não for JSON, assume-se binário para download
          const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition'] || ''
          let filename = `danfe_${cteID}.zip`
          const fileNameMatch = disposition.match(/filename\*?=([^;\n]+)/i)
          if (fileNameMatch) {
            filename = fileNameMatch[1].replace(/UTF-8''/i, '').replace(/"/g, '').trim()
          }

          const blob = new Blob([res.data], { type: contentType || 'application/zip' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)

          Swal.fire('Sucesso', 'Download iniciado.', 'success')
        }
      })
    },

    novoAnexo(){
      console.log('novoAnexo')
      this.descranexo = ''
      this.submittedAnexo = false
      this.showModalAnexo = true
      // this.activeTab = 2
    },

    confAnexo(){
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.descranexo !== '' && this.dropzoneFile.name){
        this.showModalAnexo = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/movctefileanexo`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.mediasData = res.data[0]
          this.loadingFiles = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        })
      }
    },

    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

    },

    carregarDados(){
      console.log('carregarDados')

      this.updating = true
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/movcte`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('then axios carregarDados')
          console.log(res.data)
          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          }else{
            console.log('then axios')
            console.log(res.data)
            this.movCteData = res.data[0]
            this.remetData = res.data[1]
            this.origemData = res.data[2]
            this.destinoData = res.data[3]
            this.destData = res.data[4]
            this.expedData = res.data[5]
            this.recebData = res.data[6]
            this.entregaData = res.data[7]
            this.empresaData = res.data[8]
            this.itensCteData = res.data[9]
            this.emitData = res.data[10]
            this.itensCotaData = res.data[11]
            this.mediasData = res.data[12]

            this.cotaFrtData = res.data[13]
            this.cotaFrtCalcsData = res.data[14]
            this.flagShowConciliacoes = res.data[15]

            // console.log('this.movCteData.dtemissao')
            // console.log(this.movCteData.dtemissao)

            this.itensCotaData.forEach((value) => {
              if (value.cnpjremet === 1) {
                this.itemCotaRemet = value
              }
              if (value.prazomin === 1) {
                this.itemCotaPrazoMin = value
              }
              if (value.valormin === 1) {
                this.itemCotaValorMin = value
              }
            })


            //this.movCteData.dtemissao = moment(this.movCteData.dtemissao).format('YYYY-MM-DD')

            this.idData = this.movCteData.id
            this.title = `Editar Movimento CT-e (${this.movCteData.id}) ${this.remetData ? this.remetData.nome : ''}`
            this.updating = false

            console.log('finalizou carrega CTE')

          }
        });
      }else{

        this.title = `Criando Novo CTE`
        this.updating = false
      }

    },



    abrirMov(){
      console.log('abrirMov')

      const routeData = this.$router.resolve(`/movcte/editar/${this.movCteData.id}`)
      window.open(routeData.href, '_blank')

    },


    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }

  },
  mounted() {
    console.log('mounted_cte_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    this.carregarDados()


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movCteData.status" />

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="" >

      <div class="row" v-if="!updating" >

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-start">

                <!-- CT-e cancelado (status CAN, vindo do evento da SEFAZ via
                     logstash) nao aceita mais nenhuma acao: nao ha frete a
                     cotar nem comprovante a anexar num documento que nao existe
                     mais fiscalmente. Sobram Imprimir DACTE (leitura) e o alerta
                     abaixo. -->
                <b-alert v-if="movCteData.status === 'CAN'" show variant="danger" class="mx-2 mb-0 d-flex align-items-center">
                  <i class="mdi mdi-alert-octagon me-2"></i>
                  CT-e cancelado na SEFAZ - nenhuma operacao disponivel.
                </b-alert>

                <b-button v-if="!bloqExibEconofrete && movCteData.status !== 'CAN'" variant="outline-info" class="mx-2" @click="cotarFrete" :disabled="movCteData.id === 0">
                  <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                  Cotar Frete
                </b-button>

                <b-button variant="outline-success" class="mx-2" v-if="idData > 0 && movCteData.status !== 'CAN'" @click="novoAnexo" >
                  <i class="bx bx-upload font-size-16 align-middle me-2" ></i>
                  Anexar Comprovante
                </b-button>

                <b-button variant="outline-danger" class="mx-2" @click="cancelar" :disabled="movCteData.id === 0" v-if="movCteData.status !== 'CAN'">
                  <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
                  Cancelar CTe
                </b-button>

                <b-button class="mx-2" @click="imprimirdancte" :disabled="movCteData.id === 0">
                  <i class="bx bxs-download font-size-16 align-middle me-2"></i>
                  Imprimir DACTE
                </b-button>
              </div>
            </div>
          </div>
        </div>

      </div>





      <div v-if="!updating && movCteData.codigo">

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-1
                        class="text-dark"
                        href="javascript: void(0);"
                    >Dados Principais</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
                  <b-card-body>

                    <div class="row mb-2">


                      <div class="col-md-2" >
                        <label for="codigo">Código</label>
                        <div class="position-relative">
                          <input
                              id="codigo"
                              type="text"
                              v-model="movCteData.codigo"
                              class="form-control"
                              :disabled="true"
                              placeholder="Código"/>
                        </div>
                      </div>

                      <div class="col-md-2" >
                        <label for="cfop">CFOP</label>
                        <div class="position-relative">
                          <input
                              id="cfop"
                              type="text"
                              v-model="movCteData.cfop"
                              class="form-control"
                              :disabled="true"
                              placeholder="CFOP"/>
                        </div>
                      </div>

                      <div class="col-md-2" >
                        <label for="mod">Modalidade</label>
                        <div class="position-relative">
                          <input
                              id="mod"
                              type="text"
                              v-model="movCteData.mod"
                              class="form-control"
                              :disabled="true"
                              placeholder="Modalidade"/>
                        </div>
                      </div>


                      <div class="col-md-6" >
                        <label for="natop">Natureza da Operação</label>
                        <!--                            <i class="bx bxs-bell-ring font-size-18 bx-fade-right text-danger"></i>-->
                        <div class="position-relative">
                          <input
                              id="natop"
                              type="text"
                              v-model="movCteData.natopv"
                              class="form-control"
                              :disabled="true"
                              placeholder="Natureza da Operação"/>
                        </div>
                      </div>




                    </div>

                    <div class="row mb-2">

                      <!--                      <div class="col-md-2" >-->
                      <!--                        <label for="serie">Série</label>-->
                      <!--                        <div class="position-relative">-->
                      <!--                          <input-->
                      <!--                              id="serie"-->
                      <!--                              type="text"-->
                      <!--                              v-model="movCteData.serie"-->
                      <!--                              class="form-control"-->
                      <!--                              :disabled="true"-->
                      <!--                              placeholder="Série"/>-->
                      <!--                        </div>-->
                      <!--                      </div>-->

                      <div class="col-md-2" >
                        <label for="numero">Número</label>
                        <div class="position-relative">
                          <input
                              id="numero"
                              type="text"
                              v-model="movCteData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="mb-3">
                          <label for="dtemissao">Data de Emissão</label>
                          <input
                              id="dtemissao"
                              v-model="movCteData.dtemissao"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Data de Emissão"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="mb-3">
                          <label for="dtpreventr">Previsão de Entrega</label>
                          <input
                              id="dtpreventr"
                              v-model="movCteData.dtpreventr"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Previsão de Entrega"/>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label for="chave">Chave</label>
                        <div class="position-relative">
                          <input
                              id="chave"
                              type="text"
                              v-model="movCteData.chave"
                              class="form-control"
                              :disabled="true"
                              placeholder="Chave"/>
                        </div>
                      </div>


                    </div>


                    <div class="row mb-3">

                      <div class="col-md-2" >
                        <label for="codmunenv">Cód. Mun. Enviado</label>
                        <div class="position-relative">
                          <input
                              id="codmunenv"
                              type="text"
                              v-model="movCteData.codmunenv"
                              class="form-control"
                              :disabled="true"
                              placeholder="Cód. Mun. Enviado"/>
                        </div>
                      </div>

                      <div class="col-md-4" >
                        <label for="municenv">Município Enviado</label>
                        <div class="position-relative">
                          <input
                              id="municenv"
                              type="text"
                              v-model="movCteData.municenv"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município Enviado"/>
                        </div>
                      </div>

                      <div class="col-md-2" >
                        <label for="ufenv">UF Enviado</label>
                        <div class="position-relative">
                          <input
                              id="ufenv"
                              type="text"
                              v-model="movCteData.ufenv"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF Env."/>
                        </div>
                      </div>

                      <div class="col-md-4" >
                        <label for="carac">Característica Serviço</label>
                        <div class="position-relative">
                          <input
                              id="carac"
                              type="text"
                              v-model="movCteData.carac"
                              class="form-control"
                              :disabled="true"
                              placeholder="Característica Serviço"/>
                        </div>
                      </div>

                    </div>


                    <div class="row mb-3">

                      <div class="col-md-2" >
                        <label for="codmunini">Cód. Mun. Início</label>
                        <div class="position-relative">
                          <input
                              id="codmunini"
                              type="text"
                              v-model="movCteData.codmunini"
                              class="form-control"
                              :disabled="true"
                              placeholder="Cód. Mun. Ini."/>
                        </div>
                      </div>

                      <div class="col-md-4" >
                        <label for="municini">Município Início</label>
                        <div class="position-relative">
                          <input
                              id="municini"
                              type="text"
                              v-model="movCteData.municini"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município Ini."/>
                        </div>
                      </div>

                      <div class="col-md-2" >
                        <label for="ufini">UF Início</label>
                        <div class="position-relative">
                          <input
                              id="ufini"
                              type="text"
                              v-model="movCteData.ufini"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF Início"/>
                        </div>
                      </div>

                    </div>



                    <div class="row">

                      <div class="col-md-2" >
                        <label for="codmunfim">Cód. Mun. Final</label>
                        <div class="position-relative">
                          <input
                              id="codmunfim"
                              type="text"
                              v-model="movCteData.codmunfim"
                              class="form-control"
                              :disabled="true"
                              placeholder="Cód. Mun. Final"/>
                        </div>
                      </div>

                      <div class="col-md-4" >
                        <label for="municfim">Município Final</label>
                        <div class="position-relative">
                          <input
                              id="municfim"
                              type="text"
                              v-model="movCteData.municfim"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município Final"/>
                        </div>
                      </div>

                      <div class="col-md-2" >
                        <label for="uffim">UF Final</label>
                        <div class="position-relative">
                          <input
                              id="uffim"
                              type="text"
                              v-model="movCteData.uffim"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF Final"/>
                        </div>
                      </div>

                    </div>



                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>
        </div>


        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-9
                        class="text-dark"
                        href="javascript: void(0);"
                    >Conciliação</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-9" visible accordion="my-accordion-9" role="tabpanel">
                  <b-card-body>

                    <div class="table-responsive mb-2">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>

                          <th scope="col">Obs</th>
                          <th scope="col">Nome</th>
                          <th scope="col">CNPJ</th>
                          <th scope="col" class="text-end">Prazo</th>
                          <th scope="col" class="text-end">Valor</th>
                          <th scope="col" class="text-end">Data</th>

                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="item in itensCotaData" :key="item.id">

                          <td class="text-muted mb-0">{{ item.obs }}</td>
                          <td class="text-muted mb-0">
                            <span>{{ item.nome }}</span>
                            <i class="bx bxs-user-detail font-size-18 bx-fade-right text-warning" v-if="item.cnpjremet"></i>
                          </td>
                          <td class="text-muted mb-0">
                            {{ item.cnpj }}
                            <i class="bx bxs-check-circle d-block text-success font-size-18" v-if="item.cnpjemit"></i>
                          </td>

                          <td class="text-muted mb-0 text-end">
                            <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="item.prazomin"></i>
                            <span>{{ formatDecimal(item.prazo) }}</span>
                          </td>

                          <td class="text-muted mb-0 text-end">
                            <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="item.valormin"></i>
                            <span>{{ formatDecimal(item.valor) }}</span>
                          </td>

                          <td class="text-muted mb-0 text-end">{{ formatDateTime(item.created_at) }}</td>


                        </tr>

                        </tbody>
                      </table>
                    </div>


                    <div class="row mt-2">

                      <div class="col-xl-4 col-sm-6">
                        <div class="card">
                          <div class="row">
                            <div class="col-xl-5">
                              <div class="text-center p-4 border-end">
                                <div class="avatar-sm mx-auto mb-3 mt-1">
                                  <span :class="`avatar-title rounded-circle bg-soft bg-info text-primary font-size-16`">
                                    CONCILIADO
                                  </span>
                                </div>
                                <h5 class="text-truncate pb-1">{{ itemCotaRemet.nome }}</h5>
                              </div>
                            </div>
                            <div class="col-xl-7">
                              <div class="p-4 text-center text-xl-start">
                                <div class="row">
                                  <div class="col-xs-6">
                                    <div>
                                      <p class="text-muted mb-2 text-truncate">Frete CT-e</p>
                                      <h5>R$ {{ formatDecimal(movCteData.valor) }}</h5>
                                    </div>
                                  </div>
                                  <div class="col-xs-6">
                                    <div>
                                      <p class="text-muted mb-2 text-truncate">Frete Cotado
                                        <span :class="itemCotaRemet.percdif < 0 ? 'text-success' : 'text-danger'">
                                          {{ formatDecimal(itemCotaRemet.percdif) }}%
                                        </span>
                                      </p>
                                      <h5>R$ {{ formatDecimal(itemCotaRemet.valor) }}
                                        <span :class="itemCotaRemet.valordif <= 0 ? 'text-success' : 'text-danger'">
                                          ({{ formatDecimal(itemCotaRemet.valordif) }})
                                        </span>
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4">
                                  <a href="#" class="text-decoration-underline text-reset">
                                    Prazo
                                    <i class="mdi mdi-arrow-right"></i>
                                    {{ formatInteger(itemCotaRemet.prazo) }}
                                    <span :class="itemCotaRemet.diasdif <= 0 ? 'text-success' : 'text-danger'">
                                          ({{ formatInteger(itemCotaRemet.diasdif) }})
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-4 col-sm-6" v-if="flagShowConciliacoes">
                        <div class="card">
                          <div class="row">
                            <div class="col-xl-5">
                              <div class="text-center p-4 border-end">
                                <div class="avatar-sm mx-auto mb-3 mt-1">
                                  <span :class="`avatar-title rounded-circle bg-soft bg-warning text-primary font-size-16`">
                                    MENOR PRAZO
                                  </span>
                                </div>
                                <h5 class="text-truncate pb-1">{{ itemCotaPrazoMin.nome }}</h5>
                              </div>
                            </div>
                            <div class="col-xl-7">
                              <div class="p-4 text-center text-xl-start">
                                <div class="row">
                                  <div class="col-xs-6">
                                    <div>
                                      <p class="text-muted mb-2 text-truncate">Frete CT-e</p>
                                      <h5>R$ {{ formatDecimal(movCteData.valor) }}</h5>
                                    </div>
                                  </div>
                                  <div class="col-xs-6">
                                    <div>
                                      <p class="text-muted mb-2 text-truncate">Frete Cotado
                                        <span :class="itemCotaPrazoMin.percdif < 0 ? 'text-success' : 'text-danger'">
                                          {{ formatDecimal(itemCotaPrazoMin.percdif) }}%
                                        </span>
                                      </p>
                                      <h5>R$ {{ formatDecimal(itemCotaPrazoMin.valor) }}
                                        <span :class="itemCotaPrazoMin.valordif <= 0 ? 'text-success' : 'text-danger'">
                                          ({{ formatDecimal(itemCotaPrazoMin.valordif) }})
                                        </span>
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4">
                                  <a href="#" class="text-decoration-underline text-reset">
                                    Prazo
                                    <i class="mdi mdi-arrow-right"></i>
                                    {{ formatInteger(itemCotaPrazoMin.prazo) }}
                                    <span :class="itemCotaPrazoMin.diasdif <= 0 ? 'text-success' : 'text-danger'">
                                          ({{ formatInteger(itemCotaPrazoMin.diasdif) }})
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-4 col-sm-6" v-if="flagShowConciliacoes">
                        <div class="card">
                          <div class="row">
                            <div class="col-xl-5">
                              <div class="text-center p-4 border-end">
                                <div class="avatar-sm mx-auto mb-3 mt-1">
                                  <span :class="`avatar-title rounded-circle bg-soft bg-warning text-primary font-size-16`">
                                    MENOR VALOR
                                  </span>
                                </div>
                                <h5 class="text-truncate pb-1">{{ itemCotaValorMin.nome }}</h5>
                              </div>
                            </div>
                            <div class="col-xl-7">
                              <div class="p-4 text-center text-xl-start">
                                <div class="row">
                                  <div class="col-xs-6">
                                    <div>
                                      <p class="text-muted mb-2 text-truncate">Frete CT-e</p>
                                      <h5>R$ {{ formatDecimal(movCteData.valor) }}</h5>
                                    </div>
                                  </div>
                                  <div class="col-xs-6">
                                    <div>
                                      <p class="text-muted mb-2 text-truncate">Frete Cotado
                                        <span :class="itemCotaValorMin.percdif < 0 ? 'text-success' : 'text-danger'">
                                          {{ formatDecimal(itemCotaValorMin.percdif) }}%
                                        </span>
                                      </p>
                                      <h5>R$ {{ formatDecimal(itemCotaValorMin.valor) }}
                                        <span :class="itemCotaValorMin.valordif <= 0 ? 'text-success' : 'text-danger'">
                                          ({{ formatDecimal(itemCotaValorMin.valordif) }})
                                        </span>
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                                <div class="mt-4">
                                  <a href="#" class="text-decoration-underline text-reset">
                                    Prazo
                                    <i class="mdi mdi-arrow-right"></i>
                                    {{ formatInteger(itemCotaValorMin.prazo) }}
                                    <span :class="itemCotaValorMin.diasdif <= 0 ? 'text-success' : 'text-danger'">
                                          ({{ formatInteger(itemCotaValorMin.diasdif) }})
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <h4 class="card-title">Cotações de Frete</h4>
                    <div class="row mt-2">

                      <DxDataGrid
                          key-expr="id"
                          ref="dataGridRefKey"
                          :data-source="cotaFrtCalcsData"
                          :show-borders="true"
                          :focused-row-enabled="true"
                          :column-auto-width="true"
                          :show-row-lines="true"
                          :allow-column-reordering="true"
                          :allow-column-resizing="true"
                          :row-alternation-enabled="true">

                        <DxRemoteOperations
                            :filtering="true"
                            :paging="true"
                            :sorting="true"
                            :summary="true"
                            :grouping="false"
                            :group-paging="false"/>

                        <DxColumnFixing :enabled="true"/>
                        <DxFilterRow :visible="true"/>

                        <DxExport
                            :enabled="true"
                            :allow-export-selected-data="true"/>

                        <DxGroupPanel :visible="true"/>
                        <DxGrouping/>

                        <DxColumn
                            :width="80"
                            data-field="created_at"
                            caption="Criação"
                            alignment="right"
                            data-type="datetime"
                            format="dd/MM/yyyy"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="true"/>

                        <DxColumn :width="80"
                                  sort-order="desc"
                                  data-field="id"
                                  caption="ID"
                                  alignment="right"
                                  data-type="number"
                                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                                  :allowHeaderFiltering="false">
                        </DxColumn>

                        <DxColumn
                            data-field="transpnome"
                            caption="Transportadora"
                            alignment="left"
                            data-type="text"
                            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
                            :allowHeaderFiltering="false"/>

                        <DxColumn :width="80"
                                  sort-order="desc"
                                  data-field="prazo"
                                  caption="Prazo"
                                  alignment="right"
                                  data-type="number"
                                  :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                                  :allowHeaderFiltering="false">
                        </DxColumn>

                        <DxColumn
                            :width="80"
                            data-field="freteperc"
                            caption="Frete(%)"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                        <DxColumn
                            :width="80"
                            data-field="fretekg"
                            caption="Frete Kg"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                        <DxColumn
                            :width="80"
                            data-field="cubft"
                            caption="Fator Cub."
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                        <DxColumn
                            :width="80"
                            data-field="vlricms"
                            caption="Valor ICMS"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                        <DxColumn
                            :width="80"
                            data-field="fretevalor"
                            caption="Frete R$"
                            alignment="right"
                            :format="formatDecimal"
                            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                            :allowHeaderFiltering="false"/>

                      </DxDataGrid>

                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>


            </div>
          </div>

        </b-card-text>



        <b-card-text v-if="emitData">
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-2
                       class="text-dark"
                       href="javascript: void(0);">
                      Emitente
                    </a>
                    <!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!emitCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
                  <b-card-body>

                    <div class="row mb-2" >
                      <div class="col-md-4">
                        <label for="destnome">Nome / Razão Social</label>

                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="emitData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>

                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="emitData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>



                      </div>

                      <div class="col-md-3">
                        <label for="destinsc">Inscrição Estadual</label>

                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="emitData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2">
                        <label for="desttel1">Telefone</label>

                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="emitData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label for="destender">Endereço</label>

                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="emitData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label for="destnumero">Número</label>

                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="emitData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="destbairro">Bairro</label>

                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="emitData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="destcep">CEP</label>

                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="emitData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>




                      <div class="col-md-4">
                        <label for="destmunicipio">Município</label>

                        <div class="position-relative">
                          <input
                              id="destmunicipio"
                              type="text"
                              v-model="emitData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="destestado">UF</label>

                        <div class="position-relative">
                          <input
                              id="destestado"
                              type="text"
                              v-model="emitData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>


                    </div>




                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>



        <b-card-text v-if="remetData">
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-21
                       class="text-dark"
                       href="javascript: void(0);">
                      Remetente
                    </a>
                    <!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!remetCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-21" visible accordion="my-accordion-21" role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4" >
                        <label for="destnome">Nome / Razão Social</label>

                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="remetData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>

                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="remetData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>



                      </div>

                      <div class="col-md-3">
                        <label for="destinsc">Inscrição Estadual</label>

                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="remetData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2">
                        <label for="desttel1">Telefone</label>

                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="remetData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label for="destender">Endereço</label>

                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="remetData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label for="destnumero">Número</label>

                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="remetData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="destbairro">Bairro</label>

                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="remetData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="destcep">CEP</label>

                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="remetData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>




                      <div class="col-md-4">
                        <label for="destmunicipio">Município</label>

                        <div class="position-relative">
                          <input
                              id="destmunicipio"
                              type="text"
                              v-model="remetData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="remetestado">UF</label>

                        <div class="position-relative">
                          <input
                              id="remetestado"
                              type="text"
                              v-model="remetData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>


        <b-card-text v-if="expedData">
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-22
                       class="text-dark"
                       href="javascript: void(0);">
                      Expedição
                    </a>
                    <!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!expedCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse v-if="expedData"
                            id="accordion-22"
                            visible accordion="my-accordion-22"
                            role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4" >
                        <label for="destnome">Nome / Razão Social</label>

                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="expedData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>

                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="expedData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>

                      </div>

                      <div class="col-md-3">
                        <label for="destinsc">Inscrição Estadual</label>

                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="expedData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2">
                        <label for="desttel1">Telefone</label>

                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="expedData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>




                      <div class="col-md-4">
                        <label for="destender">Endereço</label>

                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="expedData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label for="destnumero">Número</label>

                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="expedData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="destbairro">Bairro</label>

                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="expedData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="destcep">CEP</label>

                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="expedData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>



                      <div class="col-md-4">
                        <label for="expedmunicipio">Município</label>

                        <div class="position-relative">
                          <input
                              id="expedmunicipio"
                              type="text"
                              v-model="expedData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label for="expedestado">UF</label>

                        <div class="position-relative">
                          <input
                              id="expedestado"
                              type="text"
                              v-model="expedData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>




        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-23
                       class="text-dark"
                       href="javascript: void(0);">
                      Recebedor
                    </a>
                    <!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!recebCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-23"
                            visible accordion="my-accordion-23" role="tabpanel">
                  <b-card-body>

                    <div class="row" >

                      <div class="col-md-3">
                        <label for="recebcnpj">CNPJ</label>

                        <div class="position-relative">
                          <input
                              id="recebcnpj"
                              type="text"
                              v-model="movCteData.receb"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="recebrua">Endereço</label>

                        <div class="position-relative">
                          <input
                              id="recebrua"
                              type="text"
                              v-model="movCteData.recebrua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label for="recebnum">Número</label>

                        <div class="position-relative">
                          <input
                              id="recebnum"
                              type="text"
                              v-model="movCteData.recebnum"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="recebairro">Bairro</label>

                        <div class="position-relative">
                          <input
                              id="recebairro"
                              type="text"
                              v-model="movCteData.recebairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="recebcep">CEP</label>

                        <div class="position-relative">
                          <input
                              id="recebcep"
                              type="text"
                              v-model="movCteData.recebcep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>



                      <div class="col-md-4">
                        <label for="recebcidade">Município</label>

                        <div class="position-relative">
                          <input
                              id="recebcidade"
                              type="text"
                              v-model="movCteData.recebcidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="recebestado">UF</label>

                        <div class="position-relative">
                          <input
                              id="recebestado"
                              type="text"
                              v-model="movCteData.recebestado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>


                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>



        <b-card-text v-if="destData">
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-24
                       class="text-dark"
                       href="javascript: void(0);">
                      Destinatário
                    </a>
                    <!--                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!recebCompData.id"></i>-->
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-24" visible accordion="my-accordion-24" role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4" >
                        <label for="destnome">Nome / Razão Social</label>

                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="destData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>

                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="destData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>



                      </div>

                      <div class="col-md-3">
                        <label for="destinsc">Inscrição Estadual</label>

                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="destData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>



                      <div class="col-md-2">
                        <label for="desttel1">Telefone</label>

                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="destData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label for="destender">Endereço</label>

                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="destData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label for="destnumero">Número</label>

                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="destData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="destbairro">Bairro</label>

                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="destData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="destcep">CEP</label>

                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="destData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>


                      <div class="col-md-4">
                        <label for="destmunicipio">Município</label>

                        <div class="position-relative">
                          <input
                              id="destmunicipio"
                              type="text"
                              v-model="destData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>


                      <div class="col-md-3">
                        <label for="destestado">UF</label>

                        <div class="position-relative">
                          <input
                              id="destestado"
                              type="text"
                              v-model="destData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>




                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>




        <b-card-text>
          <div class="card">
            <div class="card-body">


              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">

                  <li class="list-inline-item">
                    <h6 class="m-0">
                      <a
                          v-b-toggle.accordion-4
                          class="text-dark"
                          href="javascript: void(0);"
                      >Valores e Impostos</a>
                    </h6>
                  </li>


                </b-card-header>

                <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
                  <b-card-body>


                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="bcicms">CST ICMS</label>
                        <div class="position-relative">
                          <input
                              id="bcicms"
                              type="text"
                              v-model="movCteData.icmscst"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="CST ICMS"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="bcicmsst">Base ICMS</label>
                        <div class="position-relative">
                          <input
                              id="icmsvbc"
                              type="number"
                              v-model="movCteData.icmsvbc"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Base de cálculo do ICMS"/>
                        </div>
                      </div>



                      <div class="col-md-2 text-end">
                        <label for="vlricmsst">Alíquota ICMS</label>
                        <div class="position-relative">
                          <input
                              id="icmsaliq"
                              type="number"
                              v-model="movCteData.icmsaliq"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Alíquota ICMS"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="icmsvalor">Valor ICMS</label>
                        <div class="position-relative">
                          <input
                              id="icmsvalor"
                              type="number"
                              v-model="movCteData.icmsvalor"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do ICMS"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="totaltrib">Valor total tributado</label>
                        <div class="position-relative">
                          <input
                              id="totaltrib"
                              type="number"
                              v-model="movCteData.totaltrib"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor total tributado"/>
                        </div>
                      </div>


                    </div>

                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="valorcarga">Valor Carga</label>
                        <div class="position-relative">
                          <input
                              id="valorcarga"
                              type="number"
                              v-model="movCteData.valorcarga"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Carga"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="valor">Valor Total do Frete</label>
                        <div class="position-relative">
                          <input
                              id="valor"
                              type="number"
                              v-model="movCteData.valor"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Total do Frete"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="valorfrete">Valor do frete</label>
                        <div class="position-relative">
                          <input
                              id="valorfrete"
                              type="text"
                              v-model="movCteData.valorfrete"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do frete"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="gris">GRIS</label>
                        <div class="position-relative">
                          <input
                              id="gris"
                              type="number"
                              v-model="movCteData.gris"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="GRIS"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="imprep">Imposto Rep.</label>
                        <div class="position-relative">
                          <input
                              id="imprep"
                              type="number"
                              v-model="movCteData.imprep"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Imposto Repassado"/>
                        </div>
                      </div>




                    </div>

                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="cubagem">Cubagem</label>
                        <div class="position-relative">
                          <input
                              id="cubagem"
                              type="number"
                              v-model="movCteData.cubagem"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Cubagem"/>
                        </div>
                      </div>

                    </div>

                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="pedagio">Pedágio</label>
                        <div class="position-relative">
                          <input
                              id="pedagio"
                              type="number"
                              v-model="movCteData.pedagio"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Pedágio"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="unimed">Un. Medida</label>
                        <div class="position-relative">
                          <input
                              id="unimed"
                              type="text"
                              v-model="movCteData.unimed"
                              class="form-control"
                              :disabled="true"
                              placeholder="Un. Medida"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="qtdund">Qtd.Un.</label>
                        <div class="position-relative">
                          <input
                              id="qtdund"
                              type="number"
                              v-model="movCteData.qtdund"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Qtd.Un."/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="cubdesc">Cubagem Desc.</label>
                        <div class="position-relative">
                          <input
                              id="cubdesc"
                              type="text"
                              v-model="movCteData.cubdesc"
                              class="form-control"
                              :disabled="true"
                              placeholder="Cubagem Desc."/>
                        </div>
                      </div>

                    </div>

                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="peso">Peso</label>
                        <div class="position-relative">
                          <input
                              id="peso"
                              type="number"
                              v-model="movCteData.peso"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesocub">Peso Cubagem</label>
                        <div class="position-relative">
                          <input
                              id="pesocub"
                              type="number"
                              v-model="movCteData.pesocub"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Cubagem"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesoafer">Peso Aferido</label>
                        <div class="position-relative">
                          <input
                              id="pesoafer"
                              type="number"
                              v-model="movCteData.pesoafer"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Aferido"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesovbc">Peso Base Cãlculo</label>
                        <div class="position-relative">
                          <input
                              id="pesovbc"
                              type="number"
                              v-model="movCteData.pesovbc"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Base Cãlculo"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="pesobrt">Peso Bruto</label>
                        <div class="position-relative">
                          <input
                              id="pesobrt"
                              type="number"
                              v-model="movCteData.pesobrt"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Bruto"/>
                        </div>
                      </div>

                    </div>

                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="pesodecl">Peso Declarado</label>
                        <div class="position-relative">
                          <input
                              id="pesodecl"
                              type="number"
                              v-model="movCteData.pesodecl"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Declarado"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesoinfo">Peso Informado</label>
                        <div class="position-relative">
                          <input
                              id="pesoinfo"
                              type="number"
                              v-model="movCteData.pesoinfo"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Informado"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesoreal">Peso Real</label>
                        <div class="position-relative">
                          <input
                              id="pesoreal"
                              type="number"
                              v-model="movCteData.pesoreal"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Real"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesotaxa">Peso Taxa</label>
                        <div class="position-relative">
                          <input
                              id="pesotaxa"
                              type="number"
                              v-model="movCteData.pesotaxa"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Taxa"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="pesofrete">Peso Frete</label>
                        <div class="position-relative">
                          <input
                              id="pesofrete"
                              type="number"
                              v-model="movCteData.pesofrete"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Peso Frete"/>
                        </div>
                      </div>





                    </div>


                    <div class="row mb-2">



                      <div class="col-md-12">
                        <label for="prodpredom">Produto Predominante</label>
                        <div class="position-relative">
                          <input
                              id="prodpredom"
                              type="text"
                              v-model="movCteData.prodpredom"
                              class="form-control"
                              :disabled="true"
                              placeholder="Produto Predominante"/>
                        </div>
                      </div>

                    </div>


                    <div class="row mt-5">
                      <div class="col-md-9 text-end">
                      </div>

                      <!--                      <div class="col-md-3 text-end">-->
                      <!--                        <b-button variant="outline-info" class="mx-2" @click="selecArquivo = !selecArquivo">-->
                      <!--                          <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>-->
                      <!--                          Conferência de Cálculo-->
                      <!--                        </b-button>-->
                      <!--                      </div>-->


                    </div>


                  </b-card-body>
                </b-collapse>
              </b-card>



            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-6
                        class="text-dark"
                        href="javascript: void(0);"
                    >Notas Fiscais</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
                  <b-card-body>

                    <div class="row">


                      <div class="table-responsive">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>

                            <th scope="col">Chave</th>

                          </tr>
                          </thead>
                          <tbody>

                          <tr v-for="item in itensCteData" :key="item.chave">

                            <td class="text-muted mb-0">{{ item.chave }}</td>


                          </tr>

                          </tbody>
                        </table>
                      </div>


                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>







        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-8
                        class="text-dark"
                        href="javascript: void(0);"
                    >Dados Adicionais</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-8" visible accordion="my-accordion-8" role="tabpanel">
                  <b-card-body>

                    <div class="row mb-2">
                      <div class="col-md-12">
                        <label for="inscrmun">Observações</label>
                        <div class="position-relative">
                        <textarea
                            id="inscrmun"
                            type="text"
                            rows="4"
                            v-model="movCteData.obs"
                            class="form-control"
                            :disabled="true"
                            placeholder="Observações"/>
                        </div>
                      </div>
                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>


            </div>
          </div>

        </b-card-text>

        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-12
                        class="text-dark"
                        href="javascript: void(0);"
                    >Anexos do Movimento</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-12" visible accordion="my-accordion-12" role="tabpanel">
                  <b-card-body>

                    <div class="card-body">
                      <!--                    <h4 class="card-title">Pasta de Anexos</h4>-->
                      <!--                    <p class="card-title-desc">-->
                      <!--                      Pasta de Anexos do Cliente</p>-->

                      <div class="row" v-if="loadingFiles">
                        <div class="col-12 text-center">
                          <b-spinner type="grow"
                                     class="m-6 mx-2"
                                     variant="secondary"
                                     role="status">
                          </b-spinner>
                          <b-spinner type="grow"
                                     class="m-6 mx-2"
                                     variant="secondary"
                                     role="status">
                          </b-spinner>
                          <b-spinner type="grow"
                                     class="m-6 mx-2"
                                     variant="secondary"
                                     role="status">
                          </b-spinner>
                        </div>
                      </div>



                      <div class="table-responsive" v-if="!loadingFiles">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Descrição</th>
                            <th scope="col">Arquivo</th>
                            <th scope="col">Data</th>
                            <th scope="col">Ações</th>
                          </tr>
                          </thead>
                          <tbody>

                          <tr v-for="data in mediasData" :key="data.id">

                            <td>
                              <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                              </h5>
                            </td>

                            <td>
                              {{ data.descricao }}
                            </td>

                            <td>
                        <span class="text-dark">
                          {{ data.nome }}
                        </span>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                          <span class="text-dark">
                            {{ formatDateTime(data.created_at) }}
                          </span>
                              </h5>
                            </td>


                            <td>
                              <div class="button-items">

                                <b-button variant="outline-success" @click="downFile(data.path, data.nome)">
                                  <i class="mdi mdi-download d-block font-size-16"></i>
                                </b-button>

                                <b-button variant="outline-danger" @click="delFile(data.id)" :disabled="data.email === 'admin@admin.com.br'">
                                  <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                </b-button>

                              </div>
                            </td>


                          </tr>

                          </tbody>
                        </table>
                      </div>

                    </div>



                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>
        </b-card-text>

        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-11
                        class="text-dark"
                        href="javascript: void(0);"
                    >Ocorrências Movimento</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-11" visible accordion="my-accordion-11" role="tabpanel">
                  <b-card-body>

                    <div class="card-body">
                      <!--                    <h4 class="card-title">Pasta de Anexos</h4>-->
                      <!--                    <p class="card-title-desc">-->
                      <!--                      Pasta de Anexos do Cliente</p>-->

                      <div class="row" v-if="loadingFiles">
                        <div class="col-12 text-center">
                          <b-spinner type="grow"
                                     class="m-6 mx-2"
                                     variant="secondary"
                                     role="status">
                          </b-spinner>
                          <b-spinner type="grow"
                                     class="m-6 mx-2"
                                     variant="secondary"
                                     role="status">
                          </b-spinner>
                          <b-spinner type="grow"
                                     class="m-6 mx-2"
                                     variant="secondary"
                                     role="status">
                          </b-spinner>
                        </div>
                      </div>



                      <div class="table-responsive" v-if="!loadingFiles">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Status</th>
                            <th scope="col">Tipo Envio</th>
                            <th scope="col">Usuário</th>
                            <th scope="col">Criado</th>
                            <th scope="col">Enviado</th>
                          </tr>
                          </thead>
                          <tbody>

                          <tr v-for="data in ocorrenciasData" :key="data.id">

                            <td>
                              <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                              </h5>
                            </td>

                            <td>
                              {{ nomeStatusOcor(data.status) }}
                            </td>

                            <td>
                            <span class="text-dark">
                              {{ tipoEnvioOcor(data.tpenvio) }}
                            </span>
                            </td>

                            <td>
                            <span class="text-dark">
                              {{ data.created_by }}
                            </span>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ formatDateTime(data.created_at) }}
                              </span>
                              </h5>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ formatDateTime(data.envio) }}
                              </span>
                              </h5>
                            </td>




                          </tr>

                          </tbody>
                        </table>
                      </div>

                    </div>



                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>
        </b-card-text>



      </div>

    </div>


    <b-modal size="xl"
             :title="'Cotação de Frete'"
             v-model="showModalCotarFrete"
             centered hide-footer>
      <div class="col-md-12">

        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>

        <div class="table-responsive" v-if="cotaFreteListData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Ações</th>
              <th scope="col">TranspNome</th>
              <th scope="col" class="">Frete R$</th>
              <th scope="col" class="">Frete %</th>
              <th scope="col" class="">Frete KG</th>


              <th scope="col" class="text-end">PrazoDias</th>

              <th scope="col">TranspCNPJ</th>
              <th scope="col">TranspEmail</th>
              <th scope="col" class="text-end">Mov.Cot.ID</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in cotaFreteListData" :key="data.id">
              <td>

                <a href="javascript:void(0);"
                   v-b-tooltip.hover
                   class="action-icon text-info mx-2"
                   title="Escolher Transportadora"
                   @click="escolherFrete(data.WSOut_Frete_Val)">
                  <i class="mdi mdi-check-outline font-size-18"></i>
                </a>



              </td>

              <td>
                {{ data.WSOut_Transp_Nome }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.WSOut_Frete_Val) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.valor / movCteData.valor) * 100) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.valor / movCteData.maiorpeso) * 100) }}
              </td>

              <!--              <td>-->
              <!--                <div>-->
              <!--                  <h5 class="text-truncate font-size-14">-->
              <!--                    {{ formatDateTime(data.WSOut_DataH) }}-->
              <!--                  </h5>-->
              <!--                </div>-->
              <!--              </td>-->

              <td class="text-end">
                <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                {{ data.WSOut_Prazo_Dias }}
              </td>

              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_Indic }}-->
              <!--              </td>-->
              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_MovCot_ID }}-->
              <!--              </td>-->
              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_MovSim_ID }}-->
              <!--              </td>-->
              <!--              <td>-->
              <!--                {{ data.WSOut_NotaS }}-->
              <!--              </td>-->

              <td>
                {{ data.WSOut_Transp_CNPJ }}
              </td>
              <td>
                {{ data.WSOut_Transp_Email }}
              </td>
              <td class="text-end">
                {{ data.WSOut_MovCot_ID }}
              </td>

            </tr>

            <!--            <tr>-->
            <!--              <td colspan="4">-->
            <!--                <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>-->
            <!--              </td>-->
            <!--              <td class="text-end"> {{ formatDecimal(0.00) }}</td>-->
            <!--            </tr>-->

            <!--            <tr>-->
            <!--              <td colspan="4">-->
            <!--                <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>-->
            <!--              </td>-->
            <!--              <td class="font-size-14 text-end"> {{ formatDecimal(0.00) }}</td>-->
            <!--            </tr>-->

            </tbody>
          </table>
        </div>


        <!--        <div class="mb-3">-->
        <!--          <label for="obs">Observações do Pedido</label>-->
        <!--          <textarea-->
        <!--              id="obs"-->
        <!--              v-model="movData.obs"-->
        <!--              type="text"-->
        <!--              rows="3"-->
        <!--              class="form-control"-->
        <!--              placeholder="Observações do Pedido"/>-->
        <!--        </div>-->



        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotarFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalCotarFrete = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Criar Novo Anexo (Comprovante)" v-model="showModalAnexo" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input
                    id="descranexo"
                    type="text"
                    v-model="descranexo"
                    class="form-control"
                    placeholder="Descrição do anexo"
                    :class="{'is-invalid': submittedAnexo && !descranexo}"/>
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalAnexo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>
